<template>
  <div class="paymentWrapper whitePMbg">
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>
    <b-row>
      <b-col cols="12">
        <div class="pmstatusIcon floatCss">
          <img :src="pmSuccessImg">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="paymentSuccessTop floatCss">
          <h1>Payment successful</h1>
          <p>Thank you for the payment. The documents have been sent to this email <a href="#">{{ submissionDetail.customerEmail }}</a>.</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="order in salesOrders"
        :key="order._id"
        cols="12"
      >
        <div class="paymentStslist-single floatCss">
          <div class="status-left-photo floatCss">
            <img :src="itemPhoto(order)">
          </div>
          <div class="status-rightcontent floatCss">
            <div class="status-rightcontent-inner floatCss">
              <h3>{{ submissionDetail.customerName }}</h3>
              <h4>{{ productLabel(order) }}</h4>
              <p>{{ order.stringID }}</p>
              <p v-if="order.trxNo">
                Transaction ID: {{ order.trxNo }}
              </p>
              <p v-if="order.worshipPeriodStart">
                Earliest internment date: {{ dateFormat(order.worshipPeriodStart) }}
              </p>
              <p v-else>
                Earliest internment date: Immediate
              </p>
            </div>
          </div>
          <div class="status-updatests">
            <span :class="`status-${(order.orderStatus || '').toLowerCase()}`">{{ order.orderStatus }}</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="paymentInfo.paymentMethod">
      <b-col cols="12">
        <div class="paymentSuccessBottom floatCss">
          <h3>Payment via {{ paymentInfo.paymentMethod }}</h3>
          <p>{{ paymentInfo.completedAt ? dateFormatWithTime(paymentInfo.completedAt) : '' }}</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import Loader from '../Loader.vue'

// Niche/Pedestal/Little Buddha are Lot-bound physical spaces; Urn/Funeral Service Package are
// package-based purchases with no per-item photo in the data model either way - a fixed
// placeholder per family, not a real per-purchase photo.
const LOT_BASED = ['Niche', 'Pedestal', 'Little Buddha']

export default {
  components: {
    BRow,
    BCol,
    Loader,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      pmSuccessImg: require('@/assets/images/mobile/pmSuccess.png'),
      // eslint-disable-next-line global-require
      lotPhoto: require('@/assets/images/mobile/status-photo-1.png'),
      // eslint-disable-next-line global-require
      packagePhoto: require('@/assets/images/mobile/status-photo-2.png'),
      submissionDetail: {},
      salesOrders: [],
      paymentInfo: {},
    }
  },

  beforeMount() {
    this.fetchResult()
  },

  methods: {
    itemPhoto(order) {
      return LOT_BASED.includes(order.productType) ? this.lotPhoto : this.packagePhoto
    },
    productLabel(order) {
      const location = order.lotNo ? `${order.zoneNo}-${order.lotNo}` : order.packageName
      return `${order.productType}${location ? ` (${location})` : ''}`
    },
    fetchResult() {
      const { token } = this.$route.params
      this.$http.get('front-end/payment/validate/token', { params: { token } })
        .then(response => {
          if (response.data.success && response.data.type === 'sales') {
            this.submissionDetail = response.data.submission || {}
            if (response.data.token && response.data.token._id) {
              this.fetchSalesOrders(response.data.token._id)
            }
          }
        })
    },
    fetchSalesOrders(linkID) {
      this.$http.get(`front-end/payment/token/${linkID}/check/status`)
        .then(response => {
          if (response.data.success && response.data.salesOrders) {
            this.salesOrders = response.data.salesOrders
            this.paymentInfo = response.data.payment || {}
          }
        })
    },
  },
}
</script>
